import { Component, ViewChild, inject } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@environment';
import { AuthService } from '@services/auth/auth.service';
import { EventsService } from '@services/events/events.service';
import { ScriptLoaderService } from '@services/script-loader/script-loader.service';
import { SignupService } from '@services/signup/signup.service';
import { StorageService } from '@services/storage/storage.service';
import { UtilService } from '@services/util/util.service';
import { VariablesService } from '@services/variables/variables.service';
import { MatDialogModule } from '@angular/material/dialog';

declare const google;

@Component({
  selector: 'app-google-onetap-login',
  standalone: true,
  imports: [
    MatDialogModule
  ],
  templateUrl: './google-onetap-login.component.html',
  styleUrls: ['./google-onetap-login.component.scss']
})
export class GoogleOnetapLoginComponent {

  private scriptLoader = inject(ScriptLoaderService);
  private auth = inject(AuthService);
  private signupService = inject(SignupService);
  readonly storage = inject(StorageService);
  readonly router = inject(Router);
  readonly events = inject(EventsService);
  readonly vars = inject(VariablesService);
  private util = inject(UtilService);

  @ViewChild('userinfoRef', { static: true }) public userinfoRef;

  ngOnInit() {
    const user = this.util.getUserData();
    if (typeof document !== 'undefined' && !user) {
      this.loadGoogleScript();
    }
  }

  async loadGoogleScript() {
    try {
      await this.scriptLoader.load('google_login');
      google.accounts.id.initialize({
        client_id: environment.google_client_id_one_tap,
        callback: this.handleCredentialRes.bind(this), // Whatever function you want to trigger...
        auto_select: true,
        cancel_on_tap_outside: false,
        prompt_parent_id: 'g_id_onload',
        use_fedcm_for_prompt: true
      });
      google.accounts.id.prompt((notification) => {
        // console.log('Google prompt event triggered...');
        if (notification.getDismissedReason() === 'credential_returned') {
          // console.log('Welcome back!');
          // redirect user as per requirement
        }
      });
    } catch (error) {
      console.log(error);
    }
  }

  handleCredentialRes(response) {
    // console.log(response);
    // need to call auth api here to login user in system
    this.auth.socialLogin(response.credential, 'googleonetap').subscribe((res: any) => {
      this.vars.loginType = res.data.user_exists ? 'signin' : 'signup';
      this.vars.loginMethod = 'google_onetap';
      this.signupService.afterLogin(res , 'gonetap');
      this.events.sendSystemEvent({
        eventName: 'google_one_tap_login',
      }).subscribe(_ => _);
    });
  }

}
